import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
  selector: 'app-consent-banner',
  imports: [TranslateModule],
  template: `
    @if (analyticsService.enabled && analyticsService.consent() === null) {
      <div
        class="banner"
        role="dialog"
        aria-live="polite"
        [animate.enter]="'banner-enter'"
      >
        <div class="text">
          <h4 class="title">{{ 'consent_banner.title' | translate }}</h4>
          <p class="message">{{ 'consent_banner.message' | translate }}</p>
        </div>
        <div class="actions">
          <!-- Refuser doit être aussi simple et visible qu'accepter (CNIL) -->
          <button class="cta-black stroke" (click)="analyticsService.setConsent('denied')">
            {{ 'consent_banner.refuse' | translate }}
          </button>
          <button class="cta-black" (click)="analyticsService.setConsent('granted')">
            {{ 'consent_banner.accept' | translate }}
          </button>
        </div>
      </div>
    }
  `,
  styleUrl: './consent-banner.scss',
})
export class ConsentBanner {
  protected readonly analyticsService: AnalyticsService = inject(AnalyticsService);
}
